<template>
  <div>
    <nav class="bg-nav navbar main-navbar" v-bind:class="{ isTransparent : isLandingPage }">

      <div class="inner">
        <router-link to="/">
          <img class="bs-logo" src="@/assets/images/icons/bs-logo.svg">
        </router-link>


        <section class="menu-right">

          <div class="hide-tablet">
            <router-link v-if="!isConsumerView" to="/master-search/scripts">
              DIRECTORY
            </router-link>
            <router-link v-if="!isConsumerView" to="/login">
              LOG IN
            </router-link>
          </div>


          <div class="user-menu show-only-tablet">
            <img class="hamburger" v-on:click="showMenu = true" src="@/assets/images/icons/hamburger.svg">
          </div>

        </section>
      </div>
    </nav>

    <div class="slideout-menu" v-on:click="onMenuClick($event)" v-bind:class="{ visible : showMenu }">
      <div class="inner">
        <div class="arrow-container">
          <img class="arrow-right" src="@/assets/images/icons/keyboard-arrow-right-white.svg">
        </div>

        <router-link to="/master-search/scripts" class="scripts-btn">
          DIRECTORY
        </router-link>
        <router-link to="/login">
          LOG IN
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import arrayHelper from '@/helpers/arrayHelper'

export default {
  name: 'MainNavbar',
  components: {

  },
  data () {
    return {
      showMenu:           false,
      searchQuery:        this.initializeSearchQuery()
    }
  },
  mounted () {
    this.activateNavScroll()
  },
  computed: {
    ...mapGetters(['currentPro']),
    isConsumerView () {
      return Object.keys(this.currentPro).length > 0
    },
    isLandingPage () {
      return this.$route.path === '/'
    }
  },
  methods: {
    activateNavScroll () {
      window.addEventListener('scroll', () => {
        let mainNav = $('.main-navbar')

        if (window.scrollY < 100) {  // If we are at the top of the screen
          mainNav.removeClass('fadeBackground')
        } else {
          mainNav.addClass('fadeBackground')
        }
      })
    },
    initializeSearchQuery () {
      return this.$route.query.searchQuery || ''
    },
    onMenuClick (event) {
      // Don't close menu when clicking on search/categories
      if (event.target.closest('.master-search')) return
      if (event.target.closest('.categories-menu')) return
      this.showMenu = false
    },
    onEnterSearch (newQuery) {
      let query = Object.assign({}, this.$route.query, { searchQuery: newQuery })

      this.$router.push({ name: 'MasterSearch', query: query }).catch(err => err)

      this.showMenu = false

      this.$refs.searchBarDesktop.closeCategories()
      this.$refs.searchBarMobile.closeCategories()
    },
    onClearSearch () {
      this.onEnterSearch(undefined)
    },
    onCategoryClick (category) {
      let categoryArray = this.$route.query.categories ? this.$route.query.categories.slice() : []
      let id            = category.id.toString()

      if (!Array.isArray(categoryArray)) categoryArray = [categoryArray]

      if (categoryArray.includes(id)) {
        arrayHelper.removeValue(categoryArray, id)
      } else {
        categoryArray.push(id)
      }

      let query = Object.assign({}, this.$route.query, { categories: categoryArray })

      this.$router.push({ name: 'MasterSearch', query: query }).catch(err => err)
    }
  }
}
</script>

<style lang="scss" scoped>

@import "@/assets/variables/_colors.scss";

.main-navbar {
  background-color:           $bs-primary;
  width:                      100%;
  padding:                    0.5em 1.5em;
  position:                   fixed;
  height:                     3.6em;
  z-index:                    999994;
  width:                      100%;

  &.isTransparent {
    background-color:         transparent;
  }

  &.fadeBackground, .isTransparent {
    background-color:         $bs-primary;
    -webkit-transition:       background-color 1000ms linear;
    -ms-transition:           background-color 1000ms linear;
    transition:               background-color 1000ms linear;
  }

  .inner {
    position:                 relative;
    width:                    100%;
  }

  .bs-logo {
    width:                    2em;
    height:                   2em;
  }

  .master-search {
    width:                    22em;
    position:                 absolute;
    right:                    35%;
    top:                      -0.25em;
  }

  .menu-right {

    position:                 absolute;
    right:                    0;
    top:                      0.25em;

    .hide-tablet {

      > a {
        padding:                0.5em 1.5em;
        text-decoration:        none;
        color:                  black;
        font-weight:            bold;

        &:hover {
          opacity:              0.5;
        }
      }
    }

    .user-menu {
      position:                   relative;
      display:                    inline-block;
      cursor:                     pointer;

      .hamburger {
        height:                   1.5em;
        width:                    1.5em;
      }

    }
  }
}

.slideout-menu {
  transition:               transform 1s;
  transform:                translateX(100%);
  position:                 fixed;
  top:                      0;
  bottom:                   0;
  right:                    0;
  padding:                  1em;
  z-index:                  999998; // Only sits behind modals
  background-color:         black;
  color:                    #FFFFFF;
  width:                    50%;
  min-width:                30em;

  .inner {
    width:                  100%;
    position:               relative;

    .master-search {
      position:             relative;
      right:                unset;
      margin:               1em 0;
    }

    .arrow-container {
      text-align:             right;

      > img {
        width:                1.5em;
        height:               1.5em;
      }
    }

    > a {
      color:                  white;
      padding:                1em;
      display:                block;
      border-bottom:          1px solid #9C9C9C;

      &:last-of-type {
        border-bottom:        none;
      }
    }
  }

  &.visible {
    transform:              translateX(0%);
  }
}



@media (max-width: 991px) {

  .main-navbar {

    .master-search {
      width:                  15em;
    }

    .menu-right {

      .hide-tablet {
        display:              none;
      }

    }
  }
}

/* Landscape phone to portrait tablet */
@media (max-width: 767px) {

  .main-navbar {
    padding:                  0.5em 1em;

    .master-search {
      width:                  90%;
      margin:                 1.5em 0 1em 1em;
    }
  }

}

/* Landscape phones and down */
@media (max-width: 480px) {

  .main-navbar {
    padding:                  0.5em 1em;
  }

  .slideout-menu {
    width:              100%;
    min-width:          unset;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/MainNavbar.vue